import styled from 'styled-components';
import { TNextSessionNote, TSessionDateTone } from './sessionDateSort.helpers';

// Row styling for the Session/Event Date cells while a date sort is active
// (GROW-4300): the next/current session gets a dot + red accent, sessions
// that already happened are blue (primary), and a short note under the dates
// says which shadow field drives the row.
export const DateRow = styled.div<{ $tone?: TSessionDateTone | null }>`
  display: flex;
  align-items: baseline;
  gap: 6px;

  .session-date-dot {
    width: 6px;
    height: 6px;
    flex: 0 0 6px;
    border-radius: 50%;
    background: ${({ theme, $tone }) =>
      $tone === 'next' ? theme.colorErrorDefault : 'transparent'};
  }

  ${({ theme, $tone }) =>
    $tone === 'next' &&
    `
    & * {
      color: ${theme.colorErrorActive} !important;
      font-weight: ${theme.fontWeightSemiBold} !important;
    }
  `}

  ${({ theme, $tone }) =>
    $tone === 'past' &&
    `
    & * {
      color: ${theme.colorPrimaryActive} !important;
    }
  `}
`;

export const SortNote = styled.div<{ $tone: TNextSessionNote }>`
  font-size: 12px;
  font-weight: ${({ theme }) => theme.fontWeightSemiBold};
  color: ${({ theme, $tone }) =>
    $tone === 'ALL_PAST' ? theme.colorPrimaryDefault : theme.colorErrorDefault};
  padding-left: 12px;
  margin-top: 2px;
`;
